import * as VALIDATIONPAGECONFIGURATIONS from './validationPageConfigurations.constants';
import { ValidationPageConfiguration } from '../../models';

/** LOAD */
export function loadValidationPageConfigurations() {
    return { type: VALIDATIONPAGECONFIGURATIONS.VALIDATION_PAGE_CONFIGURATIONS_LOAD };
}

export function loadValidationPageConfigurationsSuccess(data: ValidationPageConfiguration[]) {
    return { type: VALIDATIONPAGECONFIGURATIONS.VALIDATION_PAGE_CONFIGURATIONS_LOAD_SUCCESS, payload: data };
}

export function loadValidationPageConfigurationsError(error: any) {
    return { type: VALIDATIONPAGECONFIGURATIONS.VALIDATION_PAGE_CONFIGURATIONS_LOAD_ERROR, payload: error };
}


/** ADD */
export function addValidationPageConfigurations(targetValidationPageConfigurations: ValidationPageConfiguration[]) {
    return { type: VALIDATIONPAGECONFIGURATIONS.VALIDATION_PAGE_CONFIGURATIONS_ADD, payload: targetValidationPageConfigurations };
}

export function addValidationPageConfigurationsSuccess(targetValidationPageConfigurations: ValidationPageConfiguration[]) {
    return { type: VALIDATIONPAGECONFIGURATIONS.VALIDATION_PAGE_CONFIGURATIONS_ADD_SUCCESS, payload: targetValidationPageConfigurations };
}

export function addValidationPageConfigurationsError(error: any) {
    return { type: VALIDATIONPAGECONFIGURATIONS.VALIDATION_PAGE_CONFIGURATIONS_ADD_ERROR, payload: error };
}


/** UPDATE */
export function updateValidationPageConfigurations(targetValidationPageConfigurations: ValidationPageConfiguration[]) {
    return { type: VALIDATIONPAGECONFIGURATIONS.VALIDATION_PAGE_CONFIGURATIONS_UPDATE, payload: targetValidationPageConfigurations };
}

export function updateValidationPageConfigurationsSuccess(targetValidationPageConfigurations: ValidationPageConfiguration[]) {
    return { type: VALIDATIONPAGECONFIGURATIONS.VALIDATION_PAGE_CONFIGURATIONS_UPDATE_SUCCESS, payload: targetValidationPageConfigurations };
}

export function updateValidationPageConfigurationsError(error: any) {
    return { type: VALIDATIONPAGECONFIGURATIONS.VALIDATION_PAGE_CONFIGURATIONS_UPDATE_ERROR, payload: error };
}


/** DELETE */
export function deleteValidationPageConfigurations(guids: string[]) {
    return { type: VALIDATIONPAGECONFIGURATIONS.VALIDATION_PAGE_CONFIGURATIONS_DELETE, payload: guids };
}

export function deleteValidationPageConfigurationsSuccess(ValidationPageConfigurations: ValidationPageConfiguration[]) {
    return { type: VALIDATIONPAGECONFIGURATIONS.VALIDATION_PAGE_CONFIGURATIONS_DELETE_SUCCESS, payload: ValidationPageConfigurations };
}

export function deleteValidationPageConfigurationsError(error: any) {
    return { type: VALIDATIONPAGECONFIGURATIONS.VALIDATION_PAGE_CONFIGURATIONS_DELETE_ERROR, payload: error };
}